// extracted by css-extract-rspack-plugin
export default {"canvas":"canvas-UGczaz","simlinCanvas":"simlinCanvas-yeXtf1","overlay":"overlay-OXKTL_","noPointerEvents":"noPointerEvents-nLRrgT","dragRectOverlay":"dragRectOverlay-osHXOv"};